import styled from 'styled-components';
import {
  Select,
} from 'antd';
import {
  COLOR_CV_6,
} from 'constants/colors';

export const StyledAntdSelect = styled(Select)`
  &.ant-select:not(.ant-select-disabled):hover .ant-select-selector {
    border-color: ${COLOR_CV_6};
  }

  &.ant-select-focused:not(.ant-select-disabled).ant-select:not(.ant-select-customize-input) .ant-select-selector {
    box-shadow: 0 0 0 2px ${COLOR_CV_6}20;
    border-color: ${COLOR_CV_6};
  }
`;
